import { type FC } from 'react'
import { cn } from '~/utils'
import { Progress, Button } from '@bpinternal/ui-kit-next'
import { ArrowLeft } from 'lucide-react'
import { useStepNavStore } from '../../stores/useStepNavStore'

type Props = {
  backDisabled: boolean
  onBackClicked: () => void
  onSkipClicked: () => void
  className?: string
}

export const StepperProgressBar: FC<Props> = ({ className, onBackClicked, onSkipClicked, backDisabled }) => {
  const progressBarStep = useStepNavStore((state) => state.progressBarStep)
  const totalNumberSteps = useStepNavStore((state) => state.totalNumberSteps)
  const isBackDisplayed = progressBarStep > 1 && progressBarStep < 4

  return (
    <div className={cn('flex w-full flex-col gap-2', className)}>
      <div className="flex items-center gap-1">
        {isBackDisplayed && (
          <Button variant="ghost" disabled={backDisabled} onClick={onBackClicked} className="h-10 w-10">
            <ArrowLeft size={16} />
          </Button>
        )}
        <p className="text-sm font-medium">
          Step {progressBarStep} of {totalNumberSteps}
        </p>
        <Button variant="ghost" onClick={onSkipClicked} className="ml-auto text-sm font-medium text-gray-9">
          skip
        </Button>
      </div>
      <Progress value={(progressBarStep / totalNumberSteps) * 100} className="h-1 rounded-none" />
    </div>
  )
}
